// @ts-check
import User from "./models/users/user";
/**
 * @typedef {Object} Appsettings
 * @property {boolean} dev
 * @property {string} version
 * @property {string} build
 * @property {boolean} IsReady
 * @property {string} ApiUrl
 * @property {string} ApiToken
 * @property {User | null} User
 * @property {boolean} imgToDicom
 * @property {string} whatsappMessage
 */
/**
 * @type {Appsettings}
 */
export const Appsettings = {
  dev: true,
  version: "1.0.0",
  build: "20260221",
  IsReady: false,
  ApiUrl: "",
  ApiToken: "",
  User: null,
  imgToDicom: false,
  whatsappMessage: "/wp.txt",
};

/**
 * @typedef {Object} DealerInfo
 * @property {string} name
 * @property {string} address
 * @property {string} phone
 * @property {string} website
 */
/**
 * @type {DealerInfo}
 */
export const DealerInfo = {
  name: "SARAI",
  address:
    "Edificio Rodrigo Av.Bush entre primer y segundo anillo santa cruz Bolivia",
  phone: "59170866119",
  website: "",
};

/**
 * @typedef {Object} ClientSetting
 * @property {Object} Theme
 * @property {string} Theme.primary
 * @property {string} Theme.primaryForeground
 * @property {string} Theme.secondary
 * @property {string} Theme.tertiary
 * @property {string} InstitutionName
 * @property {string} DefaultCountry
 * @property {number} sharetime
 * @property {string} refNumber
 */
/**
 * @type {ClientSetting}
 */
export const ClientSetting = {
  Theme: {
    primary: "#2c8547",
    primaryForeground: "white",
    secondary: "#22252a",
    tertiary: "#ee8c39",
  },
  InstitutionName: "SARAI",
  DefaultCountry: "591",
  sharetime: 48,
  refNumber: "",
};

/**
 * @typedef {Object} ContriCode
 * @property {string} name
 * @property {string} code
 */
/**
 * @type {ContriCode[]}
 */
export const ContriCodesList = [];
